import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { EditDialogProps } from '../utils/DataTypes';
import { BILLING_CLIENTS_STRINGS } from '../constants';

const EditBillingClientsDialog: React.FC<EditDialogProps> = ({
  isDialogOpen,
  formValues,
  setFormValues,
  handleDialogClose,
  handleSave,
}) => {
  const breakout = formValues.invoice_breakout;
  const breakoutDescriptionOptions =
    breakout === 'G' || breakout === 'L'
      ? BILLING_CLIENTS_STRINGS.OPTIONS.BREAKOUT_DESCRIPTIONS.SIMPLE
      : breakout === 'L-G' || breakout === 'G-L'
      ? BILLING_CLIENTS_STRINGS.OPTIONS.BREAKOUT_DESCRIPTIONS.COMPLEX
      : [];
  return (
    <>
      <Dialog open={isDialogOpen} onClose={handleDialogClose} fullWidth>
        <DialogTitle>{BILLING_CLIENTS_STRINGS.LABELS.EDIT_DIALOG_TITLE}</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              label={BILLING_CLIENTS_STRINGS.LABELS.GP_ID}
              value={formValues.accounting_client_id || ''}
              onChange={(e) => setFormValues({ ...formValues, accounting_client_id: e.target.value })}
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel>{BILLING_CLIENTS_STRINGS.LABELS.BILLING_CYCLE}</InputLabel>
              <Select
                value={formValues.billing_cycle || ''}
                onChange={(e) => setFormValues({ ...formValues, billing_cycle: e.target.value })}
                label={BILLING_CLIENTS_STRINGS.LABELS.BILLING_CYCLE}
              >
                {BILLING_CLIENTS_STRINGS.OPTIONS.BILLING_CYCLE.map((cycle) => (
                  <MenuItem key={cycle} value={cycle}>
                    {cycle}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>{BILLING_CLIENTS_STRINGS.LABELS.INVOICE_DETAIL_LOCATION}</InputLabel>
              <Select
                value={formValues.invoice_detail_location_yn || ''}
                onChange={(e) => setFormValues({ ...formValues, invoice_detail_location_yn: e.target.value })}
                label={BILLING_CLIENTS_STRINGS.LABELS.INVOICE_DETAIL_LOCATION}
              >
                {BILLING_CLIENTS_STRINGS.OPTIONS.YES_NO.map((val) => (
                  <MenuItem key={val} value={val}>
                    {val}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>{BILLING_CLIENTS_STRINGS.LABELS.INVOICE_DETAIL_MEMBER_NAME}</InputLabel>
              <Select
                value={formValues.invoice_detail_member_name_yn || ''}
                onChange={(e) => setFormValues({ ...formValues, invoice_detail_member_name_yn: e.target.value })}
                label={BILLING_CLIENTS_STRINGS.LABELS.INVOICE_DETAIL_MEMBER_NAME}
              >
                {BILLING_CLIENTS_STRINGS.OPTIONS.YES_NO.map((val) => (
                  <MenuItem key={val} value={val}>
                    {val}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>{BILLING_CLIENTS_STRINGS.LABELS.INVOICE_BREAKOUT}</InputLabel>
              <Select
                value={formValues.invoice_breakout || ''}
                onChange={(e) => setFormValues({ ...formValues, invoice_breakout: e.target.value })}
                label={BILLING_CLIENTS_STRINGS.LABELS.INVOICE_BREAKOUT}
              >
                {BILLING_CLIENTS_STRINGS.OPTIONS.BREAKOUT.map((val) => (
                  <MenuItem key={val} value={val}>
                    {val || 'None'}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>{BILLING_CLIENTS_STRINGS.LABELS.INVOICE_BREAKOUT_DESC}</InputLabel>
              <Select
                value={formValues.invoice_breakout_description || ''}
                onChange={(e) => setFormValues({ ...formValues, invoice_breakout_description: e.target.value })}
                label={BILLING_CLIENTS_STRINGS.LABELS.INVOICE_BREAKOUT_DESC}
                disabled={breakoutDescriptionOptions.length === 0}
              >
                {breakoutDescriptionOptions.map((desc) => (
                  <MenuItem key={desc} value={desc}>
                    {desc}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>{BILLING_CLIENTS_STRINGS.LABELS.CANCEL_BUTTON}</Button>
          <Button color="primary" onClick={handleSave}>
            {BILLING_CLIENTS_STRINGS.LABELS.SAVE_BUTTON}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditBillingClientsDialog;
